import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import { LuSquareArrowOutUpRight } from "react-icons/lu";
import { FaCaretUp, FaCaretDown } from "react-icons/fa";

function Spotmarkettable({ data, itemsPerPage, currentPage, setCurrentPage }) {
  const navigate = useNavigate();
  const [sortConfig, setSortConfig] = useState({
    key: null,
    isAscending: true,
  });

  // Handle page change
  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  // Slice the data for the current page
  const offset = currentPage * itemsPerPage;
  const currentItems = data.slice(offset, offset + itemsPerPage);

  // Sort only the items displayed on the current page
  const sortedItems = React.useMemo(() => {
    if (sortConfig.key) {
      return [...currentItems].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key])
          return sortConfig.isAscending ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key])
          return sortConfig.isAscending ? 1 : -1;
        return 0;
      });
    }
    return currentItems;
  }, [currentItems, sortConfig]);

  const pageCount = Math.ceil(data.length / itemsPerPage);

  // Handle sorting logic
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      isAscending: prev.key === key ? !prev.isAscending : true, // Toggle direction for the same key
    }));
  };

  // Render sorting icons based on true/false
  const renderSortIcons = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.isAscending ? (
        <FaCaretUp style={{ cursor: "pointer" }} />
      ) : (
        <FaCaretDown style={{ cursor: "pointer" }} />
      );
    }
    return null; // No icon if the column isn't being sorted
  };

  const handleClick = () => navigate("/coindetail");

  return (
    <div className="exchangetable">
      <div className="exchange_list py-2 mt-4">
        <Table responsive className="fulllist text-center">
          <thead>
            <tr>
              <th>#</th>
              <th onClick={() => handleSort("name")}>
                Coin {renderSortIcons("name")}
              </th>
              <th onClick={() => handleSort("pair")}>
                Pair {renderSortIcons("pair")}
              </th>
              <th onClick={() => handleSort("price")}>
                Price {renderSortIcons("price")}
              </th>
              <th onClick={() => handleSort("spread")}>
                Spread {renderSortIcons("spread")}
              </th>
              <th onClick={() => handleSort("pdepth")}>
                +2% Depth {renderSortIcons("pdepth")}
              </th>
              <th onClick={() => handleSort("mdepth")}>
                -2% Depth {renderSortIcons("mdepth")}
              </th>
              <th onClick={() => handleSort("hr")}>
                24h Volume {renderSortIcons("hr")}
              </th>
              <th onClick={() => handleSort("volper")}>
                Volume % {renderSortIcons("volper")}
              </th>
              {/* <th>Last Updated</th>
              <th>Trust Score</th> */}
            </tr>
          </thead>
          <tbody>
            {sortedItems.map((item, index) => (
              <tr className="listing_coin" onClick={handleClick} key={index}>
                <td>{offset + index + 1}</td>
                <td>
                  <img
                    src={item.base_currency_img}
                    className="coin me-1"
                    alt="bnb"
                  />{" "}
                  {item.base_currencyname}
                </td>
                <td>
                  <Link target="_blank" to={item?.ticker_link}>
                    {" "}
                    {item.pair}{" "}
                    <span className="arrowlist">
                      <LuSquareArrowOutUpRight />
                    </span>
                  </Link>
                </td>
                <td>{item.price}</td>
                <td>{item.spread}</td>
                <td>{item.highdepth}</td>
                <td>{item.lowdepth}</td>
                <td>{item.volume}</td>
                <td>{item.volumeper}</td>
                {/* <td>Recently</td>
                <td>
                  <div className="rounds"></div>
                </td> */}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <ReactPaginate
        previousLabel={<MdOutlineKeyboardArrowLeft />}
        nextLabel={<MdOutlineKeyboardArrowRight />}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
    </div>
  );
}

export default Spotmarkettable;
